import { Injectable } from '@angular/core';
import { QuickActionModalComponent } from '@app/layout/quick-actions/quick-action.component';

@Injectable({ providedIn: 'root' })
export class QuickActionsModalService {
  private component: QuickActionModalComponent;

  public registerComponent(component: QuickActionModalComponent): void {
    this.component = component;
  }

  public unRegisterComponent(): void {
    this.component = null;
  }

  public showModal(): void {
    if (this.component) this.component.show();
  }
}
